// Utils
import { createFeatureToggledComponent } from '../../../feature/createFeatureToggledComponent';

// Components
import DrawingEditorToolbar, { DrawingEditorToolbarWithTransitions } from './DrawingEditorToolbar';
import DrawingEditorToolbarV2, {
    DrawingEditorToolbarV2WithTransitions,
    type DrawingEditorToolbarV2Props,
} from './DrawingEditorToolbarV2';

// Constants
import { ExperimentId } from '../../../../../common/experiments/experimentsConstants';

/**
 * Feature-flag gate for the drawing editor toolbar. Renders the Roma (v2) toolbar when the
 * imageModalV2 experiment is enabled, otherwise the existing v1 toolbar. v1 is left completely
 * untouched so flag-off users (and the slow rollout) are unaffected — no regression.
 *
 * Used by all three drawing surfaces (image modal, sketch modal, annotation editor) so they
 * flip together with the flag.
 */
const DrawingEditorToolbarSwitch = createFeatureToggledComponent<DrawingEditorToolbarV2Props>(
    ExperimentId.imageModalV2,
    DrawingEditorToolbarV2,
    DrawingEditorToolbar,
);

export const DrawingEditorToolbarWithTransitionsSwitch = createFeatureToggledComponent<DrawingEditorToolbarV2Props>(
    ExperimentId.imageModalV2,
    DrawingEditorToolbarV2WithTransitions,
    DrawingEditorToolbarWithTransitions,
);

export default DrawingEditorToolbarSwitch;
